import Message from '../../components/Message'
import  { useGeoState } from '../../components/GeoProvider'
import { useFetchText } from '../../hooks/useFetchText'

const SystemNotification = (type,key,message) => {
 
    const {showAddsubscribePop,setShowAddsubscribePop} =useGeoState()
    const { data: notification } = useFetchText('notification.json')
    return notification?.text !== undefined && (
        <div style={{display:showAddsubscribePop?'block':'none'}}>
        <Message
        type="warning"
        onDismiss={() => {
          setShowAddsubscribePop(false)
        }}
        key={1}
      >
        {notification?.text}
      </Message>
      </div>
    )
}
export default SystemNotification